var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}]},[_vm._t("default",[_vm._v("Base tab control content item")],{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }